import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { NumberedListOption, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { MessageFrame } from '../MessageFrame';
import { MessageScrollArea } from '../MessageScrollArea';
import scrollAreaStyles from '../scrollArea.module.scss';
export const GetNumberedListMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const NumberedListMessage = (param)=>{
    let { content, messageId, onOptionClick, selectedOptionId } = param;
    const { NumberedListMessageTID } = useMemo(()=>GetNumberedListMessageTID(messageId), [
        messageId
    ]);
    const disabled = onOptionClick == null || selectedOptionId != null;
    return /*#__PURE__*/ _jsxs(MessageFrame, {
        testId: NumberedListMessageTID.Root(),
        padding: "16px 0 0 0",
        fillHeight: true,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: NumberedListMessageTID.Intro(),
                className: scrollAreaStyles.framePad,
                children: content.intro
            }),
            /*#__PURE__*/ _jsx(MessageScrollArea, {
                gap: 8,
                children: content.options.map((option, index)=>/*#__PURE__*/ _jsx(NumberedListOption, {
                        testId: NumberedListMessageTID.Option(index),
                        number: index + 1,
                        label: option.label,
                        selected: option.id === selectedOptionId,
                        disabled: disabled,
                        onClick: ()=>onOptionClick === null || onOptionClick === void 0 ? void 0 : onOptionClick(messageId, option),
                        bi: {
                            name: 'agent_drafting_numbered_list_option',
                            data: {
                                option_id: option.id,
                                index
                            }
                        }
                    }, option.id))
            })
        ]
    });
};
